export default __webpack_public_path__ + "images/speaker-outline.png?78f0aca1344851fc72c573d62f79f96f";